import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { AvailableLookupOsUpdateStoreActions, AvailableLookupOsUpdateStoreStates } from '../available-lookup-os-update';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class AvailableLookupOsUpdateResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly availableLookupOsUpdateStore: Store<AvailableLookupOsUpdateStoreStates.AvailableLookupOsUpdateState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.availableLookupOsUpdateStore.dispatch(
          AvailableLookupOsUpdateStoreActions.AvailableLookupOsUpdateResolverActions.availableLookupOSUpdatesRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
